module.exports = __webpack_public_path__ + "img/menu_button_playnow_hover_cn@2x.c223959e.png";